<div class="content" ssg-draggable="true">
  <div class="header modal-header">
    <i class="icon-close-o" (click)="cancel()"></i>
    <span>{{ title }}</span>
  </div>
  <div class="main" [innerHTML]="message"></div>

  <div class="footer">
    <button status="success" (click)="submit(true)" class="btn-ok" ngbAutoFocus>
      <i class="icon-save-o iconfooter"></i>
      <span>تایید</span>
    </button>

    <button *ngIf="isConfirm()" status="danger" (click)="cancel()" class="btn-close">
      <i class="icon-cancel-24px iconfooter"></i>
      <span>انصرف</span>
    </button>
  </div>
</div>
